import React from 'react';
import { Clock } from 'lucide-react';

import Tooltip from './Tooltip';
import { EXPIRED_DOCUMENT_HINT, EXPIRED_DOCUMENT_LABEL } from '../../domain/constant/document.expiration.constant';

const ExpiredDocumentBadge = ({ hint = EXPIRED_DOCUMENT_HINT }) => (
    <Tooltip title={hint}>
        <span
            className="inline-flex items-center gap-1 ml-2.5 px-2 py-0.5 rounded-lg bg-gray-100 text-xs text-[#0009] whitespace-nowrap"
            aria-label={`${EXPIRED_DOCUMENT_LABEL}. ${hint}`}
        >
            <Clock className="!w-3 !h-3" aria-hidden="true" />
            {EXPIRED_DOCUMENT_LABEL}
        </span>
    </Tooltip>
);

export default ExpiredDocumentBadge;
